import cn from 'classnames';
import { UxFeedbackWidget } from '@edu-frontend/modules/src/shared/lib/uxFeedbackWidget';
import { UseOtklickWithHook } from '@edu-frontend/modules/src/shared/lib/otklickWidget';
import { Page, PageContent, PageUp, KeyboardContextProvider } from 'platform-components/common';
import { MODAL_FADE_THEMES } from 'platform-components/constants';
import { withHookProps } from 'platform-components';
import { Route, Switch } from 'platform-components/src/components/router/router';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import { StyleContext } from 'platform-components/utils';
import { getExperimentTestIds } from 'platform-components';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import ym from 'react-yandex-metrika';
import { Dispatch, bindActionCreators } from 'redux';
import cx from 'classnames';

import { AuthorizationModal } from 'common.components/authorization-modal/authorization-modal';
import Banner from 'common.components/banner/banner';
import ChatWidget from 'common.components/chat-widget/chat-widget';
// @ts-ignore js-file
import Footer from 'common.components/footer/footer';
import * as lessonViewCommonSelectors from 'common.components/lesson-view.common/selectors';
import { SetTeamIdCookie } from 'common.components/set-team-id-cookie/set-team-id-cookie';
import { TeamBuilderContainer } from 'common.components/team-builder/team-builder.container';
import { TrackTeacherGradeActivity } from 'common.components/track-grade-activity/track-teacher-grade-activity';
import UserPopup from 'common.components/user-popup/user-popup';
import { Communication } from 'common.components/user/communication/communication';
import * as userActions from 'common.components/user/actions';
import { actions as coursesActions } from 'store/courses/actions';

import { getIsAuthenticated, getIsTeacher } from 'platform-components/src/components/user/selectors';
import { getFeatureFlags } from 'platform-components/src/components/app-factory/selectors';

import { useTeacherReserveHandleReferral } from 'store/teacher-reserve/hooks/use-teacher-reserve-handle-referral';
import type { ReduxTeacherStore, RootAction } from '../../typings';
import LessonEditorWidget from '../lesson-editor-widget/lesson-editor-widget';
import { SalesCodeModalContainer } from '../sales-code-modal/sales-code-modal.container';
//@ts-ignore js-file
import { routes as TeacherLabRoute } from '../teacher-lab/teacher-lab';
import { TeacherModalsBuilder } from '../teacher-modals-builder/teacher-modals-builder';
import { WizardContainer } from '../wizard/wizard.container';
import { TeacherGptChatWrapper } from '../teacher-gpt-chat-wrapper/teacher-gpt-chat-wrapper';

import './teacher-page.scss';
import { TeacherOtcklickNewClass } from './teacher-otcklick-new-class';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface Props extends WrappedComponentProps, WithRouterPathProps, DispatchProps, StoreProps {}

interface Context {
    staticUrls: Record<string, string>;
    data: Record<string, any>;
    environment: string;
}

class TeacherPageClass extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
        data: PropTypes.object,
        environment: PropTypes.string.isRequired,
    };

    componentDidMount(): void {
        const {
            setWizardVariables,
            hasJoinedBeforeNewModalRelease,
            history,
            getCoursesSubjectsRequest,
            location: { search },
            isAuthenticated,
        } = this.props;
        const {
            data: { getMe: me },
        } = this.context;

        const searchParams = qs.parse(search) as Record<string, string>;

        if (hasJoinedBeforeNewModalRelease) {
            setWizardVariables({ joinedBeforeNewModalRelease: true });
        }

        if (isAuthenticated) {
            // Нам нужно знать список предметов, чтобы включать некоторые фичи
            // только тем, у кого есть определенный предмет
            getCoursesSubjectsRequest();

            ym('reachGoal', 'teacher_onboarding_return_from_passport_to_platform', {
                user_id: me?.id,
            });
            history.replace({ search: qs.stringify(searchParams, { arrayFormat: 'bracket' }) });
        }
    }

    context!: Context;

    render() {
        const {
            intl,
            location: { pathname },
            teacherGptChat,
        } = this.props;
        const {
            staticUrls,
            environment,
            data: { getMe: me },
        } = this.context;

        const isQuizEditorPath = matchPath(pathname, { path: '/lab/quiz/editor/', exact: false });
        // данный роут должен отображаться без виджета чата, header , footer
        const isLessonCardPath = matchPath(pathname, {
            path: staticUrls.labLibrarySubjectLessonCard,
            exact: true,
        });
        return (
            <StyleContext.Provider value={{ modalTheme: MODAL_FADE_THEMES.TEACHER_DARK }}>
                <UseOtklickWithHook
                    useProps={() => ({
                        service: 'schoolbook',
                        isProduction: environment === 'production',
                        theme: 'light',
                        userId: me?.user_id,
                        location: useLocation().pathname,
                        testIds: useSelector(getExperimentTestIds),
                    })}
                >
                    <TeacherOtcklickNewClass />
                    <KeyboardContextProvider>
                        <Page
                            description={intl.formatMessage({ id: 'teacher.headMeta.description' })}
                            mix="teacher-page"
                            title={intl.formatMessage({ id: 'teacher.headMeta.title' })}
                        >
                            <Helmet title={intl.formatMessage({ id: 'teacherLab.teachers' })} />
                            <Banner />
                            {/* для корректного отображения виджета чата */}
                            <div
                                className={cn('teacher-page__content-wrapper', {
                                    ['teacher-page_fullHeight']: isLessonCardPath,
                                })}
                            >
                                <PageContent>
                                    <Route
                                        path="/"
                                        render={() => (
                                            <Switch>
                                                <TeacherLabRoute />
                                            </Switch>
                                        )}
                                    />
                                </PageContent>
                                {!isLessonCardPath && (
                                    <div
                                        className={cx(
                                            'teacher-page__widgets-container',
                                            teacherGptChat && 'teacher-page__widgets-container-with-gpt-chat'
                                        )}
                                    >
                                        <div className="teacher-page__widgets-container-content">
                                            <Switch>
                                                <Route
                                                    component={LessonEditorWidget}
                                                    exact={false}
                                                    path={staticUrls.labLibrarySubject}
                                                />
                                            </Switch>
                                            <div className="teacher-page__widgets-buttons">
                                                <ChatWidget />
                                                {teacherGptChat && (
                                                    <TeacherGptChatWrapper className="teacher-page__teacher-gpt-chat-button" />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <PageUp />
                            {!isQuizEditorPath && !isLessonCardPath && <Footer />}
                            <WizardContainer />
                            <AuthorizationModal />
                            <TeacherModalsBuilder />
                            <SalesCodeModalContainer />
                            <SetTeamIdCookie />
                            <UserPopup />
                            <UxFeedbackWidget useRouterLocation={true} />
                            <TeamBuilderContainer />
                            <TrackTeacherGradeActivity />
                            <Communication />
                        </Page>
                    </KeyboardContextProvider>
                </UseOtklickWithHook>
            </StyleContext.Provider>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore) => {
    const isAuthenticated = getIsAuthenticated(storeState);

    return {
        hasJoinedBeforeNewModalRelease: lessonViewCommonSelectors.getHasJoinedBeforeNewLessonModalRelease(storeState),
        isAuthenticated,
        teacherGptChat: isAuthenticated && getIsTeacher(storeState) && getFeatureFlags(storeState)?.teacherGptChat,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) =>
    bindActionCreators(
        {
            setWizardVariables: userActions.setWizardVariables,
            referalCodeRequest: userActions.referalCodeRequest,
            getCoursesSubjectsRequest: coursesActions.getCoursesSubjectsRequest,
        },
        dispatch
    );

const Wrapped = compose(
    injectIntl,
    withRouterPath,
    connect(mapStateToProps, mapDispatchToProps),
    withHookProps(useTeacherReserveHandleReferral)
)(TeacherPageClass) as Props & React.ComponentClass;

Wrapped.displayName = 'TeacherPageWrapped';

export default Wrapped;
